import React, { useContext, useRef } from "react";
import Context from "../OriginStoryProvider";
import { useGSAP } from '@gsap/react';
import { Draggable } from "gsap/Draggable";
import gsap from "gsap";

const ImageCompare = () => {
	const {
		data: { content },
	} = useContext(Context);

	const imgCompare = useRef();
	const gallery = useRef();
	const clipped = useRef();
	const dragger = useRef();

	function handleDrag() {
		const width = gallery.current.offsetWidth;
		gsap.set(clipped.current, {clipPath: `inset(0px ${(width/2) - this.x}px 0px 0px)`});
	}
	
	useGSAP(() => {
		gsap.set(dragger.current, {xPercent: -50, y: -50});

		if (!gallery.current) return;

		Draggable.create(".chapter-2__image-compare__dragger", {
			type: "x",
			minimumMovement: 0,
			bounds: {left: (dragger.current.offsetWidth / 2) * -1, width: gallery.current.offsetWidth + dragger.current.offsetWidth},
			onDrag: handleDrag,
		});	
	}, {scope: imgCompare.current, dependencies: [content.chapters, gallery.current]});


	return (
		<div className="chapter-2__image-compare" ref={imgCompare}>
			<div className="main-grid">
				<div className="main-grid__margin"></div>
				<div className="main-grid__body chapter-2__image-compare__container">
					<div className="chapter-2__image-compare__wrap">
						<h3 className="chapter-2__image-compare__title h4">
							{content.chapters.second.compare_images.title}
						</h3>
						<div className="chapter-2__image-compare__slider-wrap" ref={gallery}>
							<img
								style={{width: "100%"}}
								srcSet={`${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1200w.webp 1200w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1600w.webp 1600w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-2000w.webp 2000w`}
								sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
								src={`${mainScript.assetPath}images/jpg/chapter-2/pomona-bookstore-slider.jpg`}
								alt={content.chapters.second.compare_images.img_new_alt}
								loading="lazy"
							/>
							<img
								className="clipped"
								style={{width: "100%"}}
								srcSet={`${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-1200w.webp 1200w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-1600w.webp 1600w, ${mainScript.assetPath}images/webp/chapter-2/pomona-bookstore-slider-1800-2000w.webp 2000w`}
								src={`${mainScript.assetPath}images/jpg/chapter-2/pomona-bookstore-slider-1800.jpg`}
								sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (min-width: 1601px) 2000px"
								alt={content.chapters.second.compare_images.img_old_alt}
								ref={clipped}
								loading="lazy"
							/>
							<img
								className="chapter-2__image-compare__dragger"
								src={`${mainScript.assetPath}images/svg/graphics/circle-red.svg`}
								alt="handle to compare images"
								ref={dragger}
								loading="lazy"
							/>
						</div>
						<p className="img-caption chapter-2__image-compare__caption">
							{content.chapters.second.compare_images.caption}
						</p>
					</div>
				</div>

				<div className="main-grid__margin"></div>
			</div>
		</div>
	);
};

export default ImageCompare;
